import { fetchApi } from "../fetchApi";

export const onChangeProductMediaURL = async ({
  product,
  context,
  company_id,
}) => {
  const { temp, ...values } = product;
  const { image1920, ...restProduct } = values;
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [
        temp.id ? [temp.id] : [],
        {
          sequence: temp.sequence || 10,
          name: temp.name || product.name,
          video_url: temp.video_url || "",
          product_tmpl_id: {
            product_variant_count: 1,
            is_product_variant: false,
            VtexAttrsIds: [],
            attribute_line_ids: [],
            is_published: false,
            can_post: false,
            show_on_hand_qty_status_button: true,
            qty_available: 0,
            uom_name: "Units",
            virtual_available: 0,
            reordering_min_qty: 0,
            reordering_max_qty: 0,
            nbr_reordering_rules: 0,
            sales_count: 0,
            id: false,
            image_1920: false,
            __last_update: "2024-05-13 08:31:36",
            related_is_instagram_active: false,
            name: false,
            sale_ok: true,
            purchase_ok: false,
            instagram_analytics: false,
            facebook_analytics: false,
            twitter_analytics: false,
            active: true,
            type: "product",
            categ_id: 1,
            default_code: false,
            barcode: false,
            list_price: 1,
            pricelist_item_count: 0,
            taxes_id: [[6, false, [1]]],
            standard_price: 0,
            company_id: 1,
            uom_id: 1,
            uom_po_id: 1,
            currency_id: 2,
            cost_currency_id: 2,
            product_variant_id: 108,
            description: false,
            invoice_policy: "order",
            service_type: "manual",
            visible_expense_policy: false,
            expense_policy: "no",
            description_sale: false,
            sale_line_warn: "no-message",
            sale_line_warn_msg: false,
            website_url: false,
            website_id: 2,
            website_sequence: false,
            public_categ_ids: [[6, false, []]],
            inventory_availability: "always",
            available_threshold: 5,
            custom_message: "",
            alternative_product_ids: [[6, false, []]],
            accessory_product_ids: [[6, false, []]],
            website_ribbon_id: false,
            supplier_taxes_id: [[6, false, [2]]],
            has_available_route_ids: false,
            route_ids: [[6, false, []]],
            route_from_categ_ids: [[6, false, []]],
            responsible_id: 2,
            weight: 1,
            weight_uom_name: "kg",
            volume: 0,
            volume_uom_name: "m³",
            sale_delay: 1,
            hs_code: false,
            tracking: "none",
            property_stock_production: 15,
            property_stock_inventory: 14,
            packaging_ids: [],
            description_pickingout: false,
            description_pickingin: false,
            description_picking: false,
            property_account_income_id: false,
            property_account_expense_id: false,
            asset_category_id: false,
            social_image_1920: false,
            product_template_image_ids: [
              [4, 8, false],
              [4, 9, false],
            ],
            message_follower_ids: [[4, 721, false]],
            activity_ids: [],
            message_ids: [[4, 1082, false]],
            ...restProduct,
          },
          image_1920: temp.image_1920,
          embed_code: temp.embed_code || false,
          id: temp.id || false,
        },
        "video_url",
        {
          sequence: "",
          name: "",
          video_url: "",
          image_1920: "",
          __last_update: "",
          embed_code: "",
          id: "",
        },
      ],
      model: "product.image",
      method: "onchange",
      kwargs: {
        context: {
          lang: context.lang,
          tz: context.tz,
          uid: context.uid,
          allowed_company_ids: [company_id],

          default_name: product.name,
        },
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };

  let response = await fetchApi({
    requestOptions,
    endpoint: "/web/dataset/call_kw/product.image/onchange",
  });
  response = JSON.parse(response);
  return response;
};
